import { render, staticRenderFns } from "./Playbook.vue?vue&type=template&id=50ac66f7&"
import script from "./Playbook.vue?vue&type=script&lang=js&"
export * from "./Playbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports